(() => {
  const root = document.getElementById('lcu-product');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const config = JSON.parse(root.querySelector('[data-lcu-config]').textContent);
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const behavior = reduced ? 'instant' : 'smooth';
  const form = root.querySelector('#lcu-form');
  const error = root.querySelector('[data-lcu-error]');
  const buttons = [...root.querySelectorAll('.lcu-atc')];
  let busy = false;
  let variant = config.variants.find(v => String(v.id) === form.elements.id.value) || config.variants[0];
  const money = value => new Intl.NumberFormat(config.locale || 'fr', {style: 'currency', currency: config.currency || 'EUR'}).format(value / 100);
  root.querySelector('[data-lcu-price]').textContent = money(variant.price);
  root.querySelector('[data-lcu-sticky-price]').textContent = money(variant.price);
  const compare = root.querySelector('[data-lcu-compare]');
  const saving = root.querySelector('[data-lcu-saving]');
  compare.hidden = saving.hidden = !(variant.compare_at_price > variant.price);
  if (!compare.hidden) {
    compare.textContent = money(variant.compare_at_price);
    saving.textContent = money(variant.compare_at_price - variant.price) + ' DE RÉDUCTION';
  }
  const unlock = () => {
    busy = false;
    buttons.forEach(button => {button.disabled = !variant.available;button.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';});
    form.removeAttribute('aria-busy');
  };
  form.addEventListener('submit', event => {
    event.preventDefault();
    if (busy || !variant.available) return;
    busy = true;
    error.hidden = true;
    form.setAttribute('aria-busy', 'true');
    buttons.forEach(button => {button.disabled = true;button.textContent = 'Ajout en cours…';});
    document.dispatchEvent(new CustomEvent('cart:add', {detail: {
      source: 'lumicold-culistack', items: [{id: variant.id, quantity: 1}],
      onSuccess: unlock,
      onError: cause => {error.textContent = cause?.message || 'Impossible d’ajouter cet article. Veuillez réessayer.';error.hidden = false;unlock();}
    }}));
  });
  const gallery = root.querySelector('[data-lcu-gallery]');
  const slides = [...gallery.children];
  const thumbs = [...root.querySelectorAll('[data-lcu-thumb]')];
  const prev = root.querySelector('[data-lcu-gallery-prev]');
  const next = root.querySelector('[data-lcu-gallery-next]');
  let active = 0;
  const updateGallery = () => {
    active = Math.max(0, Math.min(slides.length - 1, Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth))));
    thumbs.forEach((button, index) => button.setAttribute('aria-current', String(index === active)));
    prev.disabled = active === 0;next.disabled = active === slides.length - 1;
    root.querySelector('[data-lcu-gallery-count]').textContent = `${active + 1} / ${slides.length}`;
    slides.forEach((slide, index) => {if (index !== active) slide.querySelectorAll('video').forEach(video => video.pause());});
    const image = slides[active + 1]?.querySelector('img');
    if (image) image.loading = 'eager';
  };
  const go = index => gallery.scrollTo({left: Math.max(0, Math.min(index, slides.length - 1)) * gallery.clientWidth, behavior});
  prev.addEventListener('click', () => go(active - 1));
  next.addEventListener('click', () => go(active + 1));
  thumbs.forEach((button, index) => button.addEventListener('click', () => go(index)));
  gallery.addEventListener('scroll', updateGallery, {passive: true});
  root.querySelector('.lcu-gallery').addEventListener('keydown', event => {
    if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();go(active + (event.key === 'ArrowRight' ? 1 : -1));
  });
  window.addEventListener('resize', updateGallery, {passive: true});
  updateGallery();
  const selectPack = (name, changeGallery = true) => {
    if (busy) return;
    const pack = config.packs[name];
    const selected = config.variants.find(v => v.id === pack.variant_id);
    if (!selected) return;
    variant = selected;
    form.elements.id.value = variant.id;
    root.querySelector('[data-lcu-price]').textContent = money(variant.price);
    root.querySelector('[data-lcu-sticky-price]').textContent = money(variant.price);
    compare.hidden = saving.hidden = !(variant.compare_at_price > variant.price);
    if (!compare.hidden) {
      compare.textContent = money(variant.compare_at_price);
      saving.textContent = money(variant.compare_at_price - variant.price) + ' DE RÉDUCTION';
    }
    root.querySelectorAll('[data-lcu-pack]').forEach(button => {
      const active = button.dataset.lcuPack === name;
      button.classList.toggle('cs-active', active);
      button.setAttribute('aria-pressed', String(active));
      const item = config.variants.find(v => v.id === config.packs[button.dataset.lcuPack].variant_id);
      button.querySelector('.cs-current').textContent = money(item.price);
    });
    root.querySelectorAll('[data-lcu-kit]').forEach(node => {node.hidden = node.dataset.lcuKit !== name;});
    root.querySelector('.description__desktop').textContent = pack.lead;
    root.querySelector('h1').textContent = pack.title;
    pack.images.forEach((url, index) => {
      const img = slides[index]?.querySelector('img');
      if (img) {img.removeAttribute('srcset');img.src = url + (url.includes('?') ? '&' : '?') + 'width=1100';img.alt = pack.label;}
      const thumb = thumbs[index]?.querySelector('img');
      if (thumb) {thumb.removeAttribute('srcset');thumb.src = url + (url.includes('?') ? '&' : '?') + 'width=140';}
    });
    if (changeGallery) go(0);
    error.hidden = true;unlock();
  };
  root.querySelectorAll('[data-lcu-pack]').forEach(button => button.addEventListener('click', () => selectPack(button.dataset.lcuPack)));
  const initialPack = Object.keys(config.packs || {}).find(name => config.packs[name].variant_id === variant.id);
  if (initialPack) selectPack(initialPack, false);
  root.querySelectorAll('[data-lcu-carousel]').forEach(track => {
    const controls = track.nextElementSibling;
    const prev = controls.querySelector('[data-lcu-prev]');
    const next = controls.querySelector('[data-lcu-next]');
    const counter = controls.querySelector('[data-lcu-counter]');
    track.tabIndex = 0;
    const step = () => (track.children[0]?.getBoundingClientRect().width || 300) + 24;
    const update = () => {
      prev.disabled = track.scrollLeft < 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      if (counter) counter.textContent = `${Math.min(track.children.length, Math.round(track.scrollLeft / step()) + 1)} / ${track.children.length}`;
    };
    const move = delta => track.scrollBy({left: step() * delta, behavior});
    prev.addEventListener('click', () => move(-1));next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, {passive: true});
    track.addEventListener('keydown', event => {if (['ArrowLeft', 'ArrowRight'].includes(event.key)) {event.preventDefault();move(event.key === 'ArrowRight' ? 1 : -1);}});
    window.addEventListener('resize', update, {passive: true});update();
  });
  const panels = [...root.querySelectorAll('[data-cs-fh-panel]')];
  let feature = 0;
  const selectFeature = index => {
    feature = (index + panels.length) % panels.length;
    panels.forEach((panel, i) => {panel.classList.toggle('is-active', i === feature);panel.setAttribute('aria-hidden', String(i !== feature));});
    root.querySelectorAll('[data-cs-fh-dot],[data-cs-fh-pag]').forEach(button => {
      const i = Number(button.dataset.csFhDot ?? button.dataset.csFhPag);
      button.classList.toggle('is-active', i === feature);button.setAttribute('aria-pressed', String(i === feature));
    });
  };
  if (panels.length) {
    root.querySelectorAll('[data-cs-fh-prev]').forEach(button => button.addEventListener('click', () => selectFeature(feature - 1)));
    root.querySelectorAll('[data-cs-fh-next]').forEach(button => button.addEventListener('click', () => selectFeature(feature + 1)));
    root.querySelectorAll('[data-cs-fh-dot],[data-cs-fh-pag]').forEach(button => button.addEventListener('click', () => selectFeature(Number(button.dataset.csFhDot ?? button.dataset.csFhPag))));
    selectFeature(0);
  }
  root.querySelectorAll('[data-lcu-kit]').forEach(kit => {
  const pieces = [...kit.querySelectorAll('.wis-slide')];
  const piecePanels = [...kit.querySelectorAll('.wis-info')];
  let piece = 0;
  const choosePiece = index => {
    piece = Math.max(0, Math.min(pieces.length - 1, index));
    pieces.forEach((slide, i) => {slide.classList.toggle('wis-active', i === piece);slide.setAttribute('aria-pressed', String(i === piece));});
    piecePanels.forEach((panel, i) => panel.classList.toggle('wis-active', i === piece));
    kit.querySelectorAll('.wis-btn-prev').forEach(button => {button.setAttribute('aria-disabled', String(piece === 0));button.classList.toggle('wis-disabled', piece === 0);});
    kit.querySelectorAll('.wis-btn-next').forEach(button => {button.setAttribute('aria-disabled', String(piece === pieces.length - 1));button.classList.toggle('wis-disabled', piece === pieces.length - 1);});
    const track = kit.querySelector('.wis-swiper');
    if (track) track.scrollTo({left: pieces[piece].offsetLeft - pieces[0].offsetLeft, behavior});
  };
  const accessibleClick = (node, callback) => {
    node.tabIndex = 0;node.setAttribute('role', 'button');node.addEventListener('click', callback);
    node.addEventListener('keydown', event => {if (['Enter', ' '].includes(event.key)) {event.preventDefault();callback();}});
  };
  pieces.forEach((slide, index) => accessibleClick(slide, () => choosePiece(index)));
  kit.querySelectorAll('.wis-btn-prev').forEach(button => accessibleClick(button, () => choosePiece(piece - 1)));
  kit.querySelectorAll('.wis-btn-next').forEach(button => accessibleClick(button, () => choosePiece(piece + 1)));
  if (pieces.length) choosePiece(0);
  });
  root.querySelectorAll('details').forEach(details => {
    const sync = () => details.querySelector('summary')?.setAttribute('aria-expanded', String(details.open));
    details.addEventListener('toggle', sync);sync();
  });
  root.querySelectorAll('[data-cs-gb-scroll-top]').forEach(button => button.addEventListener('click', () => {form.scrollIntoView({behavior,block:'center'});form.querySelector('button').focus({preventScroll:true});}));
  root.querySelectorAll('a[href="#lcu-maintenance"]').forEach(link => link.addEventListener('click', () => {root.querySelector('#lcu-maintenance').open = true;}));
  const sticky = root.querySelector('[data-lcu-sticky]');
  let pastATC = false;
  const updateSticky = () => {sticky.hidden = !pastATC || window.matchMedia('(min-width: 990px)').matches || document.documentElement.classList.contains('gscd-scroll-lock');};
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries => {pastATC = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;updateSticky();}).observe(form);
    new MutationObserver(updateSticky).observe(document.documentElement, {attributes: true, attributeFilter: ['class']});
  }
  window.addEventListener('resize', updateSticky, {passive: true});
})();
